import React from 'react';
import doctor1 from '../../assets/work/doctorH.png';
import { BsFillArrowRightCircleFill } from 'react-icons/bs';
import doctor2 from '../../assets/work/doctorA.png';
import doctor3 from '../../assets/work/doctorMA.png';
import doctor4 from '../../assets/work/doctorMU.png';

const Doctor = () => {
  return (
    <div className="bg-[#0a192f] mx-auto min-h-screen md:pt-44 pt-40">
      <h2 className="mb-12 flex justify-center md:text-5xl text-xl p-6 bg-stone-600 text-orange-500">
        Doctor portal project details
      </h2>
      <div className="flex justify-center">
        <div className="text-5xl  md:max-w-4xl">
          <div className="card card-compact max-w-full bg-base-100 shadow-xl mb-8">
            <figure>
              <img src={doctor1} alt="Doctor Homepage" />
            </figure>
            <div className="card-body">
              <h2 className="card-title text-3xl text-orange-600 underline-offset-8 underline">
                Home Page
              </h2>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                This is the Doctor Portal's home page.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                The all services part of the homepage informs users of the services that are
                offered.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                The section for testimonials on appointments allows users to access all reviews from
                other users.
              </p>
            </div>
          </div>
          <div className="card card-compact max-w-full bg-base-100 shadow-xl mb-8">
            <figure>
              <img src={doctor2} alt="Doctor Appointment page" />
            </figure>
            <div className="card-body">
              <h2 className="card-title text-3xl text-orange-600 underline-offset-8 underline">
                Appointment Page
              </h2>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                This is the Doctor Portal's page for appointments.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                The user can select any exact date for the appointment to receive treatment using
                the appointment's date picker option.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                The user can input booking information in a modal window using the appointment's
                booking appointment choices.
              </p>
            </div>
          </div>
          <div className="card card-compact max-w-full bg-base-100 shadow-xl mb-8">
            <figure>
              <img src={doctor3} alt="all appointment" />
            </figure>
            <div className="card-body">
              <h2 className="card-title text-3xl text-orange-600 underline-offset-8 underline">
                My Appointment
              </h2>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                The user can view all of his appointments on the My Appointments page.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                User information including the date of their appointment is visible.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                The pay now button on this page allows users to pay as well.
              </p>
            </div>
          </div>
          <div className="card card-compact max-w-full bg-base-100 shadow-xl mb-8">
            <figure>
              <img src={doctor4} alt="Admin page" />
            </figure>
            <div className="card-body">
              <h2 className="card-title text-3xl text-orange-600 underline-offset-8 underline">
                Admin page
              </h2>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                This is the Doctor Portal's special admin page.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                User information is available on the admin page, where users can be added as admins
                or deleted.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                Admins can manage doctors by deleting them on the manage doctors page or adding them
                in the add a doctor page.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Doctor;
